import { render, staticRenderFns } from "./ContentComment.vue?vue&type=template&id=5d838f66&scoped=true&lang=true&"
import script from "./ContentComment.vue?vue&type=script&lang=js&"
export * from "./ContentComment.vue?vue&type=script&lang=js&"
import style0 from "./ContentComment.vue?vue&type=style&index=0&id=5d838f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d838f66",
  null
  
)

export default component.exports